import React, { useState, useEffect } from 'react';
import { COMPANY } from '../config/company';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

const CompanyLogo = ({ className = "", white = false, size = "default" }) => {
  const [settings, setSettings] = useState(null);
  
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/settings`);
        if (response.ok) {
          const data = await response.json();
          setSettings(data);
        }
      } catch (error) {
        // Fallback to localStorage
        const saved = localStorage.getItem('proestimate_settings');
        if (saved) setSettings(JSON.parse(saved));
      }
    };
    fetchSettings();
  }, []);
  
  // If company has a custom logo from database or config, use it
  const customLogo = settings?.logo || COMPANY.logoUrl;
  if (customLogo) {
    return (
      <img 
        src={customLogo} 
        alt={settings?.name || COMPANY.name}
        className={className}
      />
    );
  }
  
  // ProEstimate Logo - Clean Modern Design
  const primaryColor = white ? "#FFFFFF" : (settings?.primaryColor || COMPANY.primaryColor || "#D97706");
  const secondaryColor = white ? "#FCD34D" : (settings?.secondaryColor || COMPANY.secondaryColor || "#1F2937");
  const companyName = settings?.name || COMPANY.name || "ProEstimate";
  
  const viewBox = size === "large" ? "0 0 280 70" : "0 0 200 50";
  const fontSize = size === "large" ? "28" : "20";
  const taglineSize = size === "large" ? "9" : "7";
  
  return (
    <svg 
      className={className}
      viewBox={viewBox}
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Construction Icon - Modern Building */}
      <g>
        {/* Building blocks */}
        <rect x="5" y="32" width="8" height="14" fill={primaryColor} rx="1" />
        <rect x="15" y="24" width="8" height="22" fill={secondaryColor} rx="1" />
        <rect x="25" y="16" width="8" height="30" fill={primaryColor} rx="1" />
        
        {/* Roof */}
        <path d="M2 32 L20 10 L38 32" stroke={primaryColor} strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
        
        {/* Measurement line */}
        <line x1="36" y1="46" x2="36" y2="14" stroke={secondaryColor} strokeWidth="1.5" />
        <line x1="36" y1="18" x2="40" y2="18" stroke={secondaryColor} strokeWidth="1.5" />
        <line x1="36" y1="30" x2="40" y2="30" stroke={secondaryColor} strokeWidth="1.5" />
        <line x1="36" y1="42" x2="40" y2="42" stroke={secondaryColor} strokeWidth="1.5" />
      </g>
      
      {/* Text: Company Name */}
      <g>
        <text 
          x="48" 
          y={size === "large" ? "38" : "30"}
          fontFamily="Arial, Helvetica, sans-serif" 
          fontSize={fontSize}
          fontWeight="700"
        >
          <tspan fill={primaryColor}>Pro</tspan>
          <tspan fill={secondaryColor}>Estimate</tspan>
        </text>
        
        {/* Tagline */}
        <text 
          x="48" 
          y={size === "large" ? "52" : "42"}
          fontFamily="Arial, Helvetica, sans-serif" 
          fontSize={taglineSize}
          fontWeight="500"
          fill="#9CA3AF"
          letterSpacing="1.5"
        >
          CONSTRUCTION ESTIMATES
        </text>
      </g>
    </svg>
  );
};

export default CompanyLogo;
